enum TimeSeries {
  HOURS_24 = '24 Hours',
  DAYS_7 = '7 Days',
}

export default TimeSeries;
